const UNASSIGNED = 'Unassigned';

export const FormattingUtils = {
  getGroupName(groups, groupId) {
    let groupName = UNASSIGNED;
    if (groups && groups.length) {
      const group = groups.find((group) => group.id === groupId);
      if (group) {
        groupName = group.name;
      }
    }
    return groupName;
  },

  getBrandName(brands, brandId) {
    let brandName = UNASSIGNED;
    if (brands && brands.length) {
      const brand = brands.find((brand) => brand.id === brandId);
      if (brand) {
        brandName = brand.name;
      }
    }
    return brandName;
  },
};
